/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TicketAlertStrip } from '../../../shared/ticket/TicketAlertStrip';
import { styles } from '../posShared.styles';
import { formatPosMoney } from '../../application/posMoneyFormat';
import { formatLocalTime } from '@shared/vueltoDateTime';

function formatCashTime(iso: string): string {
  const t = formatLocalTime(iso);
  return t === '—' ? '' : t;
}

export type PosCashStatusLineProps = {
  showCashVerifying: boolean;
  activeCashSessionId: string | null;
  cashClosedMessage: string;
  cashSessionOpenedAt?: string | null;
  cashSessionOpeningAmount?: number | null;
  /** Si hay handler, el pill de caja cerrada es el atajo a abrir/gestionar caja. */
  onOpenCashManagement?: () => void;
};

/**
 * Strip de estado de caja — usa TicketAlertStrip (proto `.strip`).
 * Solo estado. Acciones (Historial, Caja) viven en el toolbar / más acciones.
 */
export function PosCashStatusLine({
  showCashVerifying,
  activeCashSessionId,
  cashClosedMessage,
  cashSessionOpenedAt = null,
  cashSessionOpeningAmount = null,
  onOpenCashManagement,
}: PosCashStatusLineProps) {
  if (showCashVerifying) {
    return (
      <View style={styles.posCashStatusLine}>
        <TicketAlertStrip
          title="Verificando caja…"
          tone="default"
          hideChevron
          compact
          testID="pos-cash-verifying"
        />
      </View>
    );
  }

  if (activeCashSessionId) {
    const subtitleParts: string[] = [];
    if (cashSessionOpenedAt) {
      subtitleParts.push(`Turno de hoy · ${formatCashTime(cashSessionOpenedAt)}`);
      if (cashSessionOpeningAmount != null) {
        subtitleParts.push(`${formatPosMoney(cashSessionOpeningAmount)} inicial`);
      }
    } else {
      subtitleParts.push('Turno de hoy');
    }
    return (
      <View style={styles.posCashStatusLine}>
        <TicketAlertStrip
          title="Caja abierta"
          subtitle={subtitleParts.join(' · ')}
          tone="default"
          onPress={onOpenCashManagement}
          accessibilityLabel="Ver caja"
          compact
          testID="pos-cash-open"
        />
      </View>
    );
  }

  return (
    <View style={styles.posCashStatusLine}>
      <TicketAlertStrip
        title="Caja cerrada"
        subtitle={cashClosedMessage}
        tone="warn"
        onPress={onOpenCashManagement}
        accessibilityLabel="Abrir caja"
        compact
        testID="pos-cash-closed"
      />
    </View>
  );
}
